import { Reducer } from 'react';
import { ScoutCalendarAction, ScoutCalendarState } from './types';

export const InitialScoutCalendarState: ScoutCalendarState = {
  snackbar: {
    message: '',
    state: 'success'
  },
  showCreateEventModal: false,
  showViewEventModal: false,
  createEventObject: {
    step: 1,
    eventType: null,
    maxCandidates: '1',
    recruiters: [],
    jobs: [],
    sessions: '1',
    breaks: '0',
    duration: '15',
    eventName: '',
    eventDescription: '',
    eventDate: new Date(),
    eventId: 0,
    candidates: [],
    dates: [],
    owner: '',
    enableVideoConferencing: false
  },
  errorsMessage: {
    eventType: '',
    duration: '',
    maxCandidates: '',
    sessions: '',
    recruiters: '',
    jobs: '',
    eventName: '',
    time: '',
    date: '',
    dates: ''
  },
  createMultipleEvents: false,
  weekStart: new Date()
};

export const ScoutCalendarReducer: Reducer<ScoutCalendarState, ScoutCalendarAction> = (
  state: ScoutCalendarState,
  action: ScoutCalendarAction
): ScoutCalendarState => {
  switch (action.type) {
    case 'SET_SNACKBAR':
      return {
        ...state,
        snackbar: action.payload
      };
    case 'SET_SHOW_CREATE_EVENT_MODAL':
      return {
        ...state,
        showCreateEventModal: action.payload
      };
    case 'SET_SHOW_VIEW_EVENT_MODAL':
      return {
        ...state,
        showViewEventModal: action.payload
      };
    case 'SET_CREATE_EVENT_OBJECT':
      return {
        ...state,
        createEventObject: {
          ...state.createEventObject,
          ...action.payload
        }
      };
    case 'SET_ERROR_MESSAGE':
      return {
        ...state,
        errorsMessage: action.payload
      };
    case 'CREATE_MULTIPLE_EVENTS':
      return {
        ...state,
        createMultipleEvents: action.payload
      };
    case 'SET_WEEK_START':
      return {
        ...state,
        weekStart: action.payload
      };
    case 'RESET_STATE':
      return { ...InitialScoutCalendarState, weekStart: state.weekStart };
    default:
      return state;
  }
};
